// extracted by mini-css-extract-plugin
export default {"thymic-episode":"_thymic-episode_v5bnWO","trash":"_trash_Lk79m9","patient-age":"_patient-age_wpqiAk"};